<elcia-card>
  <div class="flex h-full flex-col gap-4">

    <div class="flex min-w-0 flex-wrap items-center justify-between gap-2">
      <div class="flex min-w-0 items-center gap-2.5">
        <span aria-hidden="true" class="pi pi-history flex-none text-sm text-[var(--p-surface-400)]"></span>
        <span class="min-w-0 text-lg font-bold">{{ 'dashboard.product-history.title' | translate }}</span>
        @if (history().length > 0) {
          <span
            class="flex-none rounded-full bg-[var(--p-surface-200)] px-2.5 py-0.5 text-xs text-[var(--p-surface-600)] tabular-nums">
            {{ history().length }}
          </span>
        }
      </div>

      <elcia-period-navigator
        (periodChange)="setPeriod($event)"
        [periodTypes]="[PeriodType.Month, PeriodType.Quarter, PeriodType.Year]"/>
    </div>

    @if (isLoading()) {
      <div class="flex items-center justify-center py-10">
        <elcia-loader/>
      </div>
    } @else if (history().length === 0) {
      <div class="flex flex-col items-center justify-center gap-2 py-10 text-[var(--p-surface-500)]">
        <span aria-hidden="true" class="pi pi-history text-xl"></span>
        <span class="text-sm">{{ 'dashboard.product-history.empty' | translate }}</span>
      </div>
    } @else {
      <!-- No gap between entries: the rail segments must join to form one continuous line. A whole
           quarter can hold hundreds of events, so the list scrolls inside the card. -->
      <div class="flex min-h-0 flex-1 flex-col overflow-y-auto">
        @for (entry of history(); track entry.id) {
          <elcia-dashboard-product-history-item
            (onSelect)="openCustomer(entry)"
            [entry]="entry"
            [isLast]="$last"/>
        }
      </div>
    }

  </div>
</elcia-card>
